export { InfoViewComponent } from './info-view/info-view.component';
export { InfoEditComponent } from './info-edit/info-edit.component';
